import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import LoadingIndicator from './components/LoadingIndicator';

// Открывается сразу только диспетчерская (DashboardPage) — остальные вкладки грузим
// отдельными чанками по требованию, чтобы при входе не тянуть код Акты/Отчёты/Чат/
// Сотрудники/Настройки, которым панель ещё не пользуется
const EmployeesPage = lazy(() => import('./pages/EmployeesPage'));
const ActsPage = lazy(() => import('./pages/ActsPage'));
const DocumentsPage = lazy(() => import('./pages/DocumentsPage'));
const MediaPage = lazy(() => import('./pages/MediaPage'));
const TechnicianReportsPage = lazy(() => import('./pages/TechnicianReportsPage'));
const OneCExportPage = lazy(() => import('./pages/OneCExportPage'));
const NightOrdersPage = lazy(() => import('./pages/NightOrdersPage'));
const ChatPage = lazy(() => import('./pages/ChatPage'));
const SettingsPage = lazy(() => import('./pages/SettingsPage'));
const OrderDetailPage = lazy(() => import('./pages/OrderDetailPage'));
const CreateOrderPage = lazy(() => import('./pages/CreateOrderPage'));
const CounterpartiesPage = lazy(() => import('./pages/CounterpartiesPage'));
const KnowledgeBasePage = lazy(() => import('./pages/KnowledgeBasePage'));
const MaintenancePage = lazy(() => import('./pages/MaintenancePage'));
const DocumentEditorPage = lazy(() => import('./pages/DocumentEditorPage'));
const InspectionsPage = lazy(() => import('./pages/InspectionsPage'));

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route
              path="/orders/new"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <CreateOrderPage />
                </Suspense>
              }
            />
            <Route
              path="/orders/:orderId"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <OrderDetailPage />
                </Suspense>
              }
            />
            <Route
              path="/employees"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <EmployeesPage />
                </Suspense>
              }
            />
            <Route
              path="/acts"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <ActsPage />
                </Suspense>
              }
            />
            <Route
              path="/documents"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <DocumentsPage />
                </Suspense>
              }
            />
            <Route
              path="/media"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <MediaPage />
                </Suspense>
              }
            />
            <Route
              path="/technician-reports"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <TechnicianReportsPage />
                </Suspense>
              }
            />
            <Route
              path="/onec-export"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <OneCExportPage />
                </Suspense>
              }
            />
            <Route
              path="/night-orders"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <NightOrdersPage />
                </Suspense>
              }
            />
            <Route
              path="/chat"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <ChatPage />
                </Suspense>
              }
            />
            <Route
              path="/kb"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <KnowledgeBasePage />
                </Suspense>
              }
            />
            <Route
              path="/maintenance"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <MaintenancePage />
                </Suspense>
              }
            />
            <Route
              path="/document-editor/:actId?"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <DocumentEditorPage />
                </Suspense>
              }
            />
            <Route
              path="/inspections"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <InspectionsPage />
                </Suspense>
              }
            />
            <Route
              path="/counterparties"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <CounterpartiesPage />
                </Suspense>
              }
            />
            <Route
              path="/settings"
              element={
                <Suspense fallback={<LoadingIndicator />}>
                  <SettingsPage />
                </Suspense>
              }
            />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
